import { defineMessage, MessageDescriptor } from 'react-intl';

/**
 * Label for "Load order params" when a single order is selected.
 */
export const loadOrderParamsMessage = defineMessage({
  id: 'audit.gipReport.form.loadOrderParams',
  defaultMessage: 'Cargar parámetros de orden',
});

/**
 * Label for "Load order params" when multiple orders are selected.
 */
export const loadOrderParamsMultipleMessage = defineMessage({
  id: 'audit.gipReport.form.loadOrderParamsMultiple',
  defaultMessage: 'Cargar parámetros de órdenes',
});

/**
 * Message descriptors for load order params button (single vs multiple).
 */
export const loadOrderParamsMessages: {
  single: MessageDescriptor;
  multiple: MessageDescriptor;
} = {
  single: loadOrderParamsMessage,
  multiple: loadOrderParamsMultipleMessage,
};
